import { SkyDialog, SkyText } from "@skypointcloud/skypoint-ui";
import { PendingIcon } from "@/lib/icons";

/**
 * The automatic-logoff warning (FR-14, SEC-14).
 *
 * The dialog cannot be dismissed by Escape or a backdrop click: the two actions
 * are the only ways out, because "I clicked outside it" is not an answer to
 * "are you still there?". Continuing restarts the idle clock; doing nothing
 * signs out and is audited with `metadata.reason = idle`.
 */
export function IdleTimeoutDialog({
  open,
  secondsRemaining,
  onContinue,
  onSignOut,
}: {
  open: boolean;
  secondsRemaining: number;
  onContinue: () => void;
  onSignOut: () => void;
}) {
  return (
    <SkyDialog
      open={open}
      onOpenChange={() => {}}
      showCloseButton={false}
      size="small"
      title="Are you still there?"
      testId="idle-timeout-dialog"
      primaryAction={{ label: "Stay signed in", onClick: onContinue }}
      secondaryAction={{ label: "Sign out", onClick: onSignOut }}
    >
      <div className="flex items-center gap-3 py-2">
        <PendingIcon className="h-8 w-8 text-muted-foreground" />
        <div>
          <SkyText as="p" size={300} block>
            You will be signed out in{" "}
            <span data-testid="idle-seconds-remaining" className="font-semibold">
              {secondsRemaining}
            </span>{" "}
            seconds.
          </SkyText>
          <SkyText as="p" size={200} color="muted" block>
            skyData ends idle sessions to keep this instance secure.
          </SkyText>
        </div>
      </div>
    </SkyDialog>
  );
}
